import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { saveUserMeta } from '../../api/mutations';
import { getThemeUnAuth, getUserMeta } from '../../api/queries';
import ApiErrorMessage from '../../components/apiErrorMessage';
import BackButton from '../../components/backButton';
import Button from '../../components/button';
import H1 from '../../components/h1';
import Select from '../../components/select';
import Spacer from '../../components/spacer';
import Loading from '../../layouts/loading';
import AppState from '../../store/appstate';

const cookies = new Cookies();

function Onboarding3() {
  const { t } = useTranslation('onboarding');
  const history = useHistory();
  const theme = getThemeUnAuth();

  const userMeta = getUserMeta();
  const saveUserMetaMutation = saveUserMeta();
  const onboarding = AppState.useState((s) => s.onboarding);
  const [terms, setTerms] = useState(false);
  const [apiError, setApiError] = useState('');
  const [valid, setValid] = useState(true);
  const [pending, setPending] = useState(false);

  const saveUser = async () => {
    setValid(false);
    setApiError('');
    setPending(true);
    const data = onboarding;

    saveUserMetaMutation.reset();

    saveUserMetaMutation.mutate(data, {
      onSuccess: () => {
        userMeta.refetch();
        setTimeout(() => {
          history.push('/');
          setPending(false);
        }, 2000);
      },
      onError: (error) => {
        setValid(true);
        setApiError(`${error}`);
        setPending(false);
      },

    });
  };

  const howHear = AppState.useState((s) => s.onboarding?.howHear);
  useEffect(() => {
    if (cookies.get('s-ref')) {
      AppState.update((s) => {
        s.onboarding.howHear = cookies.get('s-ref');
      });
    }
  }, [cookies.get('s-ref')]);

  if (theme.isSuccess) {
    const options = theme.data.hear_about_options.split('\r\n').map((o) => ({ name: o, value: o }));
    if (cookies.get('s-ref') && !options.find((o) => o.name === cookies.get('s-ref'))) {
      options.push({ name: cookies.get('s-ref'), value: cookies.get('s-ref') });
    }

    return (
      <div className="container mx-auto">
        <div className="flex flex-col justify-center items-center text-white p-4 text-center min-h-screen-minus-footer">

          {theme.data.show_hear_about && (
            <>
              <H1>
                {t('onboarding:how-did-you-hear-header')}
                ?
              </H1>
              <Spacer />

              <Select
                name="hearabout"
                className="w-full lg:w-1/3 text-sentric-dark-gray"
                placeholder={t('onboarding:please-select')}
                value={howHear}
                onChange={(option) => {
                  AppState.update((s) => { s.onboarding.howHear = option; });
                }}
                options={options}
              />
              <Spacer />
            </>
          )}

          <div>
            <label className=" text-xl" htmlFor="scales">
              <input
                type="checkbox"
                id="scales"
                name="scales"
                className="mr-4"
                value={terms}
                onClick={(e) => setTerms(e.target.checked)}
              />
              {t('onboarding:to-continue-please-read')}
              {' '}
              <a className="underline" target="_blank" href="/terms-and-conditions">{t('onboarding:terms-and-conds')}</a>

            </label>
          </div>
          <Spacer />
          {terms}
          <ApiErrorMessage apiError={apiError} />

          <div className="flex flex-row">
            <BackButton onClick={() => history.goBack()}>{t('onboarding:back-button')}</BackButton>
            <Button pending={pending} disabled={!terms || !valid} onClick={saveUser}>{t('onboarding:next-step-button')}</Button>

          </div>
          <Spacer />

        </div>
      </div>
    );
  }
  return <Loading />;
}

export default Onboarding3;
